import { render } from "./BorderControl.vue?vue&type=template&id=a8fcdf3c&scoped=true"
import script from "./BorderControl.vue?vue&type=script&lang=js"
export * from "./BorderControl.vue?vue&type=script&lang=js"

import "./BorderControl.vue?vue&type=style&index=0&id=a8fcdf3c&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a8fcdf3c"]])

export default __exports__